import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-comp-wa-progress-bar',
	templateUrl:'./WaProgressBarPage.html',
	styles: [],
	styleUrls:['./WaProgressBarPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class WaProgressBarPage
{
	mdContent_424 = `\`\`\`java
import com.jwebmp.webawesome.components.progressbar.WaProgressBar;
\`\`\``;
	mdContent_425 = `\`\`\`java
var bar = new WaProgressBar<>();
bar.setValue(60);
bar.setLabel("Uploading...");
\`\`\``;
	mdContent_426 = `\`\`\`java
var bar = new WaProgressBar<>();
bar.setIndeterminate(true);
\`\`\``;
}
